import { colors } from '@flex-design-system/fx-colors';
import { keyframes } from '@flex-design-system/stitches-react';

const baseTimingFunctions = {
  // tooltip, popover 등 translate효과가 없고 scale이 포함된 경우 약간의 spring 효과
  spring: "cubic-bezier(0.48, 1.93, 1, 0.68)",
  // overlay등에 사용되는 smooth한 효과
  smooth: "cubic-bezier(0.2, 1, 0.8, 1)",
  // modal 또는 대상의 translate 움직임이 있을 때 대부분의 경우
  expo: "cubic-bezier(0.16, 1, 0.3, 1)"
};
const baseDurations = {
  superFast: "100ms",
  fast: "150ms",
  quick: "180ms",
  default: "200ms",
  // 기본
  slow: "240ms",
  superSlow: "300ms"
};
const fadeAnimation = {
  duration: { open: baseDurations.quick, close: baseDurations.quick },
  timingFunction: baseTimingFunctions.smooth,
  show: () => keyframes({
    "0%": { opacity: 0 },
    "100%": { opacity: 1 }
  }),
  hide: () => keyframes({
    "0%": { opacity: 1 },
    "100%": { opacity: 0 }
  })
};
const slideAnimation = {
  duration: { open: baseDurations.slow, close: baseDurations.default },
  timingFunction: baseTimingFunctions.expo,
  show: (fromX = "5%", fromY = "0") => keyframes({
    "0%": {
      opacity: 0,
      transform: `translate(${fromX}, ${fromY})`
    },
    "100%": { opacity: 1, transform: "translate(0, 0)" }
  }),
  hide: (toX = "5%", toY = "0") => keyframes({
    "0%": { opacity: 1, transform: `translate(0, 0)` },
    "100%": {
      opacity: 0,
      transform: `translate(${toX}, ${toY})`
    }
  })
};
const scaleSmallAnimation = {
  duration: { open: baseDurations.fast, close: baseDurations.fast },
  timingFunction: baseTimingFunctions.spring,
  show: (scaleFrom = 0.98) => keyframes({
    "0%": { opacity: 0, transform: `scale(${scaleFrom})` },
    "100%": { opacity: 1, transform: "scale(1)" }
  }),
  hide: (scaleTo = 0.99) => keyframes({
    "0%": { opacity: 1, transform: "scale(1)" },
    "100%": { opacity: 0, transform: `scale(${scaleTo})` }
  })
};
const scaleAnimation = {
  duration: { open: baseDurations.quick, close: baseDurations.quick },
  timingFunction: baseTimingFunctions.expo,
  show: (scaleFrom = 0.98) => keyframes({
    "0%": { opacity: 0, transform: `scale(${scaleFrom})` },
    "100%": { opacity: 1, transform: "scale(1)" }
  }),
  hide: (scaleTo = 0.99) => keyframes({
    "0%": { opacity: 1, transform: "scale(1)" },
    "100%": { opacity: 0, transform: `scale(${scaleTo})` }
  })
};
const highlightColorMap = {
  CREATED: colors.yellowLight,
  UPDATED: colors.yellowLight,
  DELETED: colors.orange
};
const highlightAnimation = {
  // TODO: 튜닝 필요 @flex-jiyong
  duration: {
    created: "350ms",
    updated: "350ms",
    deleted: "1.8s"
  },
  timingFunction: baseTimingFunctions.smooth,
  show: ({
    type = "UPDATED",
    toBackgroundColor = "inherit",
    fromCSS,
    toCSS
  }) => keyframes({
    "0%": {
      backgroundColor: highlightColorMap[type],
      ...fromCSS
    },
    "100%": { backgroundColor: toBackgroundColor, ...toCSS }
  })
};
const nothing = keyframes({
  from: {},
  to: {}
});
const highlightPropsForAnimatePresence = {
  initial: {
    backgroundColor: highlightColorMap.CREATED
  },
  animate: {
    backgroundColor: colors.white,
    // 다른 색상인 경우 사용처에서 override하세요.
    transition: {
      ease: [0.2, 1, 0.8, 1],
      duration: 0.35
    }
  },
  exit: {
    backgroundColor: highlightColorMap.DELETED,
    transition: {
      ease: [0.2, 1, 0.8, 1],
      duration: 0.35
    }
  }
};

export { baseDurations, baseTimingFunctions, fadeAnimation, highlightAnimation, highlightColorMap, highlightPropsForAnimatePresence, nothing, scaleAnimation, scaleSmallAnimation, slideAnimation };
//# sourceMappingURL=keyframes.mjs.map
